import { ClassValue } from "clsx";
import { cn } from "@drpcrd/utils/shared";
import { ReactNode } from "react";

type Props = {
  className?: ClassValue;
  children?: ReactNode;
  contentClassName?: string;
};

/**
 * Layout container for creator pages that handles proper spacing designed for the centered page layout only
 *
 * They contain a special padding top and a white background to match figma designs
 */
export const CreatorPageCenteredLayout = ({
  className,
  children,
  contentClassName,
}: Props) => (
  <div
    className={cn(
      "bg-bg-primary relative flex h-auto w-full grow flex-col items-center justify-center overflow-y-auto pt-10",
      className,
    )}
  >
    {/* Target max-width is 54un, so we set max-w-56 and use px-2 (2un each side) to achieve the desired 54-unit content width with proper spacing */}
    <div
      className={cn(
        "flex h-full w-full max-w-56 flex-col px-2 sm:!px-1",
        contentClassName,
      )}
    >
      {children}
    </div>
  </div>
);
